import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as d, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTransfer",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.647.147a.5.5 0 0 1 .707 0l1.25 1.25a.5.5 0 0 1 0 .707l-1.25 1.25a.5.5 0 0 1-.707-.707l.396-.397H8.25a.5.5 0 0 1 0-1h1.793L9.647.854a.5.5 0 0 1 0-.707ZM2.009 2.034a.036.036 0 0 0-.002.016c.027.548.141 1.466.553 2.508l1.129-.94a.125.125 0 0 0 .04-.127l-.348-1.396A.125.125 0 0 0 3.26 2H2.083a.092.092 0 0 0-.066.023.035.035 0 0 0-.008.011Zm.992 3.459 1.328-1.108c.331-.276.476-.718.371-1.136l-.349-1.397A1.125 1.125 0 0 0 3.26 1H2.083c-.577 0-1.106.457-1.075 1.1a9.101 9.101 0 0 0 2.675 5.94c2.216 2.218 4.921 2.772 6.137 2.911.669.077 1.18-.463 1.18-1.077V8.738c0-.516-.352-.966-.853-1.091l-1.439-.359a1.125 1.125 0 0 0-1.068.296L6.393 8.832A8.804 8.804 0 0 1 4.39 7.334a8.225 8.225 0 0 1-1.389-1.841Zm4.35 3.796a9.891 9.891 0 0 0 2.583.67.05.05 0 0 0 .023-.002.046.046 0 0 0 .016-.01.096.096 0 0 0 .027-.072V8.738a.125.125 0 0 0-.095-.12l-1.439-.36a.125.125 0 0 0-.118.033l-.997.998Zm1.003-6.642a.5.5 0 0 1 0 .707l-.397.396H9.75a.5.5 0 0 1 0 1H7.957l.397.397a.5.5 0 0 1-.707.707l-1.25-1.25a.5.5 0 0 1 0-.707v-.001l1.25-1.25a.5.5 0 0 1 .707 0Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  f
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, I, l, H, b, t) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--transfer"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Transfer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ o(c, [["render", v]]);
export {
  w as default
};
//# sourceMappingURL=transfer.js.map
